<script setup lang="ts">
import type { NotificationEntry, NotificationMessage } from './types';

export interface NotificationProps {
  value?: NotificationEntry | NotificationMessage;
}

defineProps<NotificationProps>();

defineEmits(['click:close']);
</script>

<template>
  <v-alert
    v-if="value"
    :closable="value.closable === undefined || value.closable"
    :type="value.type"
    :title="value.title"
    :icon="value.icon"
    variant="tonal"
    density="compact"
    :data-testid="`alert_${value.type}`"
    @click:close="$emit('click:close', $event)"
  >
    <template #text>
      <slot>{{ value.message }}</slot>

      <slot name="append" v-bind="{ notification: value }" />

      <p v-if="value.stackTrace" class="code">
        {{ value.stackTrace }}
      </p>
    </template>
  </v-alert>
</template>

<style lang="scss" scoped>
@use '@/styles/variables';

.v-alert {
  line-height: normal;
  font-size: 14px;
  white-space: pre-line;
}
</style>
